<div fxLayout="column" [class]="notificationClass" ngClass="bfx-notification-embedded">
  <!-- Container with details and buttons -->
  <div class="bfx-notification-container">
    <!-- body of notification with header and details-->
    <div class="bfx-notification-details">
      <!-- Title row with icon, title, timestamp and close button-->
      <div class="bfx-notification-header">
        <div class="bfx-notification-icon">
          <i [class]="iconClass"></i>
        </div>
        <div fxFlexAlign="start" class="bfx-notification-title">{{data.title}}</div>
        <div
          class="bfx-notification-date"
          fxFlexAlign="end"
          title="{{data.time | date:'dd-MMM-yyyy'}} {{data.time | date:'HH:mm:ss'}}"
          *ngIf="data.payload && data.payload.length==1"
        >
          {{relativeTimeString}}
        </div>
      </div>
      <!-- Main notification body - 2 rows, one for primary body, opne for secondary body -->
      <!-- Multi-row notification body -->
      <!-- body of notification text -->
      <div fxLayout="column" class="bfx-notification-body">
        <div class="bfx-notification-body-primary">
          <div class="bfx-notification-body-primary-left" title="{{ data.body }}">
            {{data.body }}
          </div>
          <div
            class="bfx-notification-body-primary-right"
            *ngIf="data.payload&&data.payload.length==1"
          >
            {{data.bodyType}}
          </div>
        </div>
        <div class="bfx-notification-body-secondary">
          <div
            class="bfx-notification-body-secondary-left"
            title="{{ data.footer }}"
            *ngIf="data.payload&&data.payload.length==1"
          >
            {{data.footer}}
          </div>
          <div
            class="bfx-notification-body-secondary-right bfx-notify-actionable"
            *ngIf="data.payload&&data.payload.length==1"
            (click)="action(data.footerAction)"
          >
            {{(data.payloadIds&&data.payloadIds.length>0) ? (data.payload[0].as_action_id ?
            data.payload[0].as_action_id : data.payload[0].as_notify_ref) : ''}}
          </div>
        </div>
      </div>
    </div>
    <!-- Right-most column for buttons-->
    <div fxLayout="column" class="bfx-notification-button-container">
      <button class="bfx-icon-button-sm bfx-icon-button-on-dark-subtle-unsized" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
</div>
